import React from "react";

import { Tooltip } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import SkeletonComponent from "Components/Generic/Skeleton";
import { useCustomerPortalJobContext } from "Context/CustomerPortalJobContext";
import { useTranslation } from "react-i18next";

import useStyles, { ButtonEscalation, ContactIcon } from "../../styles";

export const OrderContactButton = () => {
  const { t: translate } = useTranslation();
  const { handleClickButtonEscalation, isLoading } = useCustomerPortalJobContext();
  const classes = useStyles();

  return (
    <Tooltip placement="top" title={translate("contactUs")}>
      <div>
        <SkeletonComponent isLoading={isLoading} classesName={classes.contactUsLoading}>
          <ButtonEscalation onClick={handleClickButtonEscalation}>
            <ContactIcon height={16} width={16} color={colors.gray600} />

            <span>{translate("contactUs")}</span>
          </ButtonEscalation>
        </SkeletonComponent>
      </div>
    </Tooltip>
  );
};
